// extracted by mini-css-extract-plugin
module.exports =  {"iframe":"_2787e5dfdf--iframe--fIE_f","loading":"_2787e5dfdf--loading--RBb0y","container":"_2787e5dfdf--container--NmEeA","loader-wrapper":"_2787e5dfdf--loader-wrapper--N8ORi"};